import { ApolloError } from "@apollo/client";
import { atom, useAtom } from "jotai";
import { SetStateAction } from "react";

export function useServiceStatus(): [
  ServicesStatus,
  (update: SetStateAction<ServicesStatus>) => void | Promise<void>,
] {
  return useAtom(serviceStatusAtom);
}
type ServiceStatus = {
  degraded: boolean;
  breakerOpen?: boolean;
  latestError?: ApolloError | null;
  showBannerTimer?: number | null;
};
export type ServicesStatus = {
  midgard: ServiceStatus;
  machemetry: ServiceStatus;
  askr: ServiceStatus;
};
const serviceStatusAtom = atom<ServicesStatus>({
  midgard: {
    degraded: false,
    breakerOpen: false,
    latestError: null,
    showBannerTimer: null,
  },
  machemetry: { degraded: false },
  askr: { degraded: false },
});
